import React, { useState } from 'react';

import { ReactComponent as Error } from '../../../assets/svg/icon_info.svg';
import { ActionLink, EmailTooltip } from '../index';
import './input.scss';

function Input({
  labelValue,
  name,
  fieldType,
  placeholder,
  value,
  handleChange,
  onBlurChange,
  errorMessage,
  actionLinkValue,
  actionLinkRedirect,
  emailToolTip,
  inputClassNames = '',
  isDisabled = false,
  isMandatory = true,
}) {
  // For Password icon toggling
  const [isPasswordShown, setIsPasswordShown] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordShown(!isPasswordShown);
  };

  return (
    <div className="form-input input-wrapper">
      <label htmlFor={fieldType}>
        {labelValue}
        {isMandatory && <sup>*</sup>}
      </label>
      {fieldType === 'email' ? <EmailTooltip emailToolTip={emailToolTip} /> : null}
      {fieldType === 'password' && actionLinkValue && actionLinkRedirect ? (
        <ActionLink value={actionLinkValue} redirectTo={actionLinkRedirect} />
      ) : null}
      <div className="input-field-wrapper">
       <input
        className={
          errorMessage ? 'form-control input-field input-field-error' : 'form-control input-field'
        }
        name={name}
        type={isPasswordShown ? 'text' : fieldType}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onBlur = {onBlurChange}
        disabled={isDisabled}
      />

        {fieldType === 'password' && isPasswordShown === false ? (
          <i className="fas fa-eye-slash password-icon" onClick={togglePasswordVisibility}></i>
        ) : (
          fieldType === 'password' && (
            <i className="fas fa-eye password-icon" onClick={togglePasswordVisibility}></i>
          )
        )}
      </div>
      {errorMessage && errorMessage.length > 0 ? (
        <div className="error-wrapper">
          <Error className="error-icon" /> <span>{errorMessage}</span>
        </div>
      ) : null}
    </div>
  );
}

export default Input;

// Input.defaultProps={
//   type:propTypes.string
// }

// Input.propTypes = {
//   name:propTypes.string,
//   type:propTypes.string.isRequired,
//   placeholder:propTypes.string,
//   value:propTypes.string.isRequired
// }
